import moment from 'moment'
import Vue from 'vue'
export default {
  securityToken: function(state) {
    return `BEARER ${state.userid} ${state.accessToken} ${
      state.privilege && state.privilege.role ? state.privilege.role : ''
    }`
  },
  isLoading: function(state) {
    return state.loading
  },
  isLoggedIn: function(state) {
    return state.isLoggedIn
  },
  unsubscribedPage: function(state) {
    let pagelist = []
    if (state.pagelist) {
      state.pagelist.map(function(pageValue, pageIndex) {
        let isFound = false
        if (state.botlist) {
          state.botlist.map(function(botValue, botIndex) {
            if (botValue.pageid === pageValue.id) {
              isFound = true
              return false
            }
          })
        }

        if (!isFound) {
          pagelist.push(pageValue)
        }
      })
    }

    return pagelist
  },
  allPage: function(state) {
    let pagelist = []

    if (state.pagelist) {
      state.pagelist.map(function(pageValue, pageIndex) {
        let isFound = false
        if (state.botlist) {
          state.botlist.map(function(botValue, botIndex) {
            if (botValue.pageid === pageValue.id) {
              isFound = true
              return false
            }
          })
        }

        pageValue.isInstallBot = isFound
        pagelist.push(pageValue)
      })
    }

    return pagelist
  },
  selectedBot: function(state) {
    if (state.selectedBot == null) {
      return null
    }

    var selectedBot = state.selectedBot

    var now = moment()
    var expriedDate = moment(state.selectedBot.expireat)
    selectedBot.expriedDate = parseInt(expriedDate.diff(now, 'days'))
    selectedBot.expriedTime = parseInt(expriedDate.diff(now, 'seconds'))
    // selectedBot.ketshop_api_key = 'aaa'
    // selectedBot.ketshop_api_secret = 'aaa'
    try {
      var date = moment(selectedBot.livechat_expireat)
      var expriedLivechatTime = parseInt(date.diff(now, 'seconds'))
      selectedBot.isUnlockLivechat = expriedLivechatTime > 0 ? true : false
    } catch (error) {
      selectedBot.isUnlockLivechat = false
    }
    return selectedBot
  },
  botlist: function(state) {
    try {
      var bots = state.botlist.map(el => {
        try {
          var now = moment()
          var date = moment(el.livechat_expireat)
          var expriedTime = parseInt(date.diff(now, 'seconds'))
          return {
            ...el,
            isUnlockLivechat: expriedTime > 0 ? true : false
          }
        } catch (error) {
          return {
            ...el,
            isUnlockLivechat: false
          }
        }
      })
    } catch (error) {
      return []
    }

    return bots
  },
  isSelectedBot: function(state) {
    return state.isSelectedBot
  },
  paypalTrackingId: function(state) {
    return state.paypalTrackingId
  },
  setting: function(state) {
    return state.setting
  },
  welcomeMessage: function(state) {
    return state.welcomeMessage
  },

  showModalWelcome: function(state) {
    return state.showModalWelcome
  },
  isFacebook: function(state) {
    return state.isFacebook
  },
  getPackage: function(state) {
    var now = moment()
    if (!state.selectedBot) {
      return 'normal'
    }
    var date = moment(state.selectedBot.expireat)
    var expriedTime = parseInt(date.diff(now, 'seconds'))
    return expriedTime > 0 ? 'premium' : 'normal'
  },
  currentLang: function(state) {
    return Vue.i18n.locale()
  },
  showAlert: state => type => {
    if (!state.selectedBot) {
      return -1
    }
    return state.alert.findIndex(function(el) {
      return el.name === type && el.pageid === state.selectedBot.pageid
    })
  },
  getCategories: function(state) {
    return state.ecommerce.categories
  },
  getBotPageRole: function(state) {
    let pagelist = []
    if (state.pagelist) {
      state.pagelist.map(function(pageValue, pageIndex) {
        let isFound = false
        if (state.botlist) {
          state.botlist.map(function(botValue, botIndex) {
            if (botValue.pageid === pageValue.id) {
              isFound = true
              return false
            }
          })
        }

        pageValue.isInstallBot = isFound
        pagelist.push(pageValue)
      })
    }
    var bot = pagelist.find(function(val, index) {
      return val.id == state.selectedBot.pageid
    })
    if (bot) {
      if (bot.perms) {
        return bot.perms.indexOf('ADMINISTER') > -1
      } else if (bot.tasks) {
        return bot.tasks.indexOf('MANAGE') > -1
      }
    } else {
      return null
    }
  },
  getLoadingCategory: function(state) {
    return state.ecommerce.loadingCategory
  },
  getProducts: function(state) {
    return state.ecommerce.products
  },
  getLoadingProduct: function(state) {
    return state.ecommerce.loadingProduct
  },
  getUserStatus: function(state) {
    return state.userStatus
  },
  getLoadingUserStatus: function(state) {
    return state.loadingUserStatus
  },
  getLoadingSetting: function(state) {
    return state.loadingSetting
  },
  getSetting: function(state) {
    return state.setting
  },
  getLoadingCharges: function(state) {
    return state.ecommerce.loadingCharges
  },
  getCharges: function(state) {
    return state.ecommerce.charges
  },
  getLoadingLinePushMessageCount: function(state) {
    return state.linePushMessageCount
  },
  getLinePushMessageCount: function(state) {
    return state.loadingLinePushMessageCount
  },
  getLivechatUsers: function(state) {
    return type => {
      if (state.livechat && state.livechat.userlist[type]) {
        return state.livechat.userlist[type].users
      } else {
        return []
      }
    }
  },
  getCurrentUser: function(state) {
    return state.livechat.currentUser
  },
  allSchools: function(state) {
    return state.allSchools
  },
  getPageProfile: function(state) {
    return state.pageProfile
  },
  getLoadingPageProfile: function(state) {
    return state.loadingPageProfile
  },
  getLoadingPartnerProfile: function(state) {
    return state.loadingPartnerProfile
  },
  getPartnerProfile: function(state) {
    return state.partnerProfile
  },
  // ticketing
  getLoadingAgentGroup: function(state) {
    return state.loadingAgentGroups
  },
  getAgentGroup: function(state) {
    return state.agentGroups
  },
  getLoadingAgentSubgroup: function(state) {
    return state.loadingAgentSubgroups
  },
  getAgentSubgroup: function(state) {
    return state.agentSubgroups
  },
  getLoadingAgent: function(state) {
    return state.loadingAgents
  },
  getAgent: function(state) {
    return state.agents
  },
  isMonix: function(state) {
    return ['114683640172785'].includes(state.selectedBot.pageid)
  },
  isLivechatSearching: function(state) {
    return !(
      state.livechat.filter.search == '' &&
      state.livechat.filter.tags.length == 0 &&
      state.livechat.filter.status == null &&
      state.livechat.filter.app == '' &&
      !state.livechat.filter.uuAreaName &&
      !state.livechat.filter.uu_name &&
      !state.livechat.filter.phoneno &&
      !state.livechat.filter.uu_register_status &&
      !state.livechat.filter.lastconversationtodate &&
      !state.livechat.filter.lastconversationtotime &&
      !state.livechat.filter.lastconversationfromdate &&
      !state.livechat.filter.lastconversationfromtime &&
      !state.livechat.filter.assignadminname &&
      !state.livechat.filter.session &&
      !state.livechat.filter.realname &&
      !state.livechat.filter.cardnumber
    )
  },
  getShippingAddress: function(state) {
    if (state.selectedBot == null && state.selectedBot.shopaddressarray == null) {
      return null
    }
    try {
      return JSON.parse(state.selectedBot.shopaddressarray)
    } catch (error) {
      return null
    }
  },
  getLivechatSearching(state) {
    var result = Object.keys(state.livechat.filter).map(key => {
      return { name: key, value: state.livechat.filter[key] }
    }, [])
    return result.filter(el => {
      return (
        el.value != '' && el.value != null && !(typeof el.value == Array && el.value.length == 0)
      )
    })
  },
  getDelayCustomerImport(state) {
    if (state.delayImportUserTime.length == 0) return true
    else {
      var delayTime = state.delayImportUserTime.find(el => {
        return el.pageid == state.selectedBot.pageid
      })
      if (delayTime) {
        var now = moment()
        var date = moment(delayTime.time)
        return parseInt(date.diff(now, 'seconds'))
      } else {
        return true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js